
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/articles",
      function () {
        return require("private-next-pages/resources/articles/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/articles"])
      });
    }
  